import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"

import { rollbar } from "@/utils/rollbar"

import backend from "./backend"
import common_en from "./en/common.json"
import common_nl from "./nl/common.json"

// ----------------------------------------------------------------------

const detectionOptions = {
  order: ["localStorage", "navigator"],
  lookupLocalStorage: "Language",
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(backend)
  .init({
    //backend: backendOptions,
    detection: detectionOptions,
    partialBundledLanguages: true,
    resources: {
      en: {
        common: common_en,
      },
      nl: {
        common: common_nl,
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "nl"],
    debug: false,
    ns: ["common"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    saveMissing: true,
    react: {
      useSuspense: true,
    },
    missingKeyHandler: (lng, ns, key) => {
      rollbar.warning(`Missing key: ${key}, ns: ${ns}, lng: ${lng}`)
      console.log(`Missing key: ${key}, ns: ${ns}, lng: ${lng}`)
    },
  })

export default i18n
